import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    authentication,
    businessPartner,
    customerType,
    editionPartsHierarchy,
    orderResponse,
    page,
    selectedMarket,
    selectedOffer,
    selectedTemplate,
    userProfile,
} from '../redux/Selectors.js';
import { logging } from '../redux/Actions.js';

/**
 * 
 * @param {*} props 
 * @returns 
 */
export const LoggingService = () => {
    const dispatch = useDispatch();
    const _authentication = useSelector((state) => authentication(state));
    const _businessPartner = useSelector((state) => businessPartner(state));
    const _customerType = useSelector((state) => customerType(state));
    const _editionPartsHierarchy = useSelector((state) => editionPartsHierarchy(state));
    const _orderResponse = useSelector((state) => orderResponse(state));
    const _page = useSelector((state) => page(state));
    const _selectedMarket = useSelector((state) => selectedMarket(state));
    const _selectedOffer = useSelector((state) => selectedOffer(state));
    const _selectedTemplate = useSelector((state) => selectedTemplate(state));
    const _userProfile = useSelector((state) => userProfile(state));

    useEffect(() => {
        if (_authentication) {
            dispatch(logging('TRACE', `WebstoreTracking.authentication() authentication=${JSON.stringify(_authentication)}`));
        }
    }, [_authentication]);

    useEffect(() => {
        if (_businessPartner) {
            dispatch(logging('TRACE', `WebstoreTracking.businessPartner() businessPartner=${JSON.stringify(_businessPartner)} `));
        }
    }, [_businessPartner]);

    useEffect(() => {
        if (_page) {
            dispatch(logging('DEBUG', `WebstoreTracking._pageChanged() page=${_page} `));
        }
    }, [_page]);

    useEffect(() => {
        if (_orderResponse) {
            dispatch(logging('TRACE', `WebstoreTracking.orderResponse() orderResponse=${JSON.stringify(_orderResponse)} `));
        }
    }, [_orderResponse]);

    useEffect(() => {
        if (_selectedMarket) {
            dispatch(logging('TRACE', `WebstoreTracking.selectedMarket() shortName=${_selectedMarket.shortName} `));
        }
    }, [_selectedMarket]);

    useEffect(() => {
        if (_selectedOffer) {
            dispatch(logging('TRACE', `WebstoreTracking.selectedOffer() shortName=${_selectedOffer.shortName} `));
        }
    }, [_selectedOffer]);

    useEffect(() => {
        if (_selectedTemplate) {
            dispatch(logging('TRACE', `WebstoreTracking.selectedTemplate() shortName=${_selectedTemplate.shortName} formxName=${_selectedTemplate.formxName} `));
        }
    }, [_selectedTemplate]);

    // ZEN-28813: Diagnose-Logging fuer leere Rubrik-Dropdowns.
    // Loggt, sobald sich die editionPartsHierarchy aendert, mit welchen
    // Parametern sie befuellt wurde und wie viele Top-Level-Eintraege
    // die Rubrik-Selectbox damit anzeigen kann.
    useEffect(() => {
        if (_editionPartsHierarchy !== undefined) {
            const items = _editionPartsHierarchy ?? [];
            const itemIds = items.map(it => it._id).join(',');
            dispatch(logging('DEBUG',
                `WebstoreTracking.editionPartsHierarchyLoaded()`
                + ` customerType=${_customerType}`
                + ` marketId=${_selectedMarket?._id}`
                + ` offerId=${_selectedOffer?._id}`
                + ` templateId=${_selectedTemplate?._id}`
                + ` defaultAdEdPartId=${_selectedTemplate?.defaultAdEdPartId}`
                + ` count=${items.length}`
                + ` itemIds=[${itemIds}]`));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_editionPartsHierarchy]);

    useEffect(() => {
        if (_userProfile) {
            dispatch(logging('TRACE', `WebstoreTracking._userProfile() userProfile=${JSON.stringify(_userProfile)} `));
        }
    }, [_userProfile]);

    return null;
}


// _pageChanged() {
// 	this.dispatch(this.actions.logging('DEBUG', `WebstoreTracking._pageChanged() previousPage = ${ this.previousPage || 'template' } page = ${ this.page } `));
// }



// _draftResponse() {
// 	if (this.draftResponse) {
// 		this.dispatch(this.actions.logging('TRACE', `WebstoreTracking._draftResponse() draftResponse = ${ JSON.stringify(this.draftResponse) } `));
// 	}
// }

